import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
export const MostrarFecha = ({ porcentaje }) => {
  if (porcentaje >= 0) {
    return <ArrowDropUpIcon sx={{ fontSize: 50, color: "green" }} />;
  }
  return <ArrowDropDownIcon sx={{ fontSize: 50, color: "red" }} />;
};
